import React from "react";
import { MemoryRouter as Router, Route, Switch } from "react-router-dom";
import PageNotFound from "./PageNotFound";
import FormCreationPage from "./FormCreation";
import ChooseTemplate from "./ChooseTemplate";
import Dashboard from "./Dashboard";
import FormListPage from "./FormListPage";
import FormEntries from "./FormEntries";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// const baseName = "/app";
function App() {
	return (
		<div>
			<Router>
				<Switch>
					<Route exact path="/" component={FormCreationPage} />
					<Route path="/choose-template" component={ChooseTemplate} />
					<Route path="/dashboard" component={Dashboard} />
					<Route path="/forms" render={(props) => <FormListPage {...props} />} />
					<Route path="/form-entries" render={(props) => <FormEntries {...props} />} />
					<Route component={PageNotFound} />
				</Switch>
			</Router>
			<ToastContainer autoClose={3000} hideProgressBar />
		</div>
	);
}

export default App;
